import { PageId } from 'constants/pages'

export const enum PageIdWoofzNdd80 {
  SUBSCRIPTIONS_NDD_80 = PageId.SUBSCRIPTIONS_NDD_80,
  CHAT_UPSELL_NDD_80 = PageId.CHAT_UPSELL_NDD_80,
  UPSELL_NDD_80 = PageId.UPSELL_NDD_80,
  DOWNLOAD_NDD_80 = PageId.DOWNLOAD_NDD_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
